import { IWorkspaceStore } from "./types";

export const getContextMenuId = (store: IWorkspaceStore) => store.contextMenuId;

export const getSetContextMenuId = (store: IWorkspaceStore) => store.setContextMenuId;